(function () {
    'use strict';

    angular
        .module('app.influencerManagementLogDetailed')
        .factory('influencerManagementLogDetailedService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getInfluencerManagementLogDetailed(influencer_management_log_id, loader) {
                    var url_getInfluencerManagementLogDetailed = $rootScope.apiUrl + 'admin/getInfluencerManagementLogDetailed?influencer_management_log_id=' + influencer_management_log_id;
                    return handleRequest(url_getInfluencerManagementLogDetailed, 'GET', null, loader);
                }

                service.getInfluencerManagementLogDetailed = getInfluencerManagementLogDetailed;
                return service;
            }
        ]);
})();
